import type { Dispatch } from 'redux';
import { getAppState, invalidateCachedContacts, getFavorites } from '../../../appstate';
import {
    unfavoriteMultiplePersonas,
    editFavoritePersona,
} from '../data/favoriteAddRemoveDataActions';
import {
    HubPersona,
    getMatchingFavorite,
    PersonType,
    FavoriteEntity,
    createThunk,
    ThunkDispatch,
} from '../../../shared';

export function invalidateLpcCachedContacts(
    dispatch: Dispatch,
    deletedHubPersonas: HubPersona[]
): void {
    const deletedPersonaIds = deletedHubPersonas
        .map(hubPersona =>
            hubPersona.type !== PersonType.FavoritePrivateDistributionList &&
            hubPersona.type !== PersonType.FavoriteUnifiedGroup
                ? hubPersona.personaId
                : undefined
        )
        .filter(id => !!id);

    invalidateCachedContacts(dispatch)(deletedPersonaIds);
}

export function unfavoriteDeletedPersonas(
    dispatch: Dispatch,
    getState: () => {},
    deletedHubPersonas: HubPersona[]
): void {
    const appState = getAppState(getState());
    const favorites = getFavorites(appState);
    const deletedFavorites = deletedHubPersonas
        .map(hubPersona => getMatchingFavorite(hubPersona, favorites))
        .filter(favorite => !!favorite);

    unfavoriteMultiplePersonas(deletedFavorites, dispatch);
}

export const editMatchingFavoritePersona = (
    updatedHubPersona: HubPersona,
    updatedInfo: Partial<FavoriteEntity>
) =>
    createThunk('EditMatchingFavorite', (dispatch: ThunkDispatch, getState: () => {}): void => {
        const appState = getAppState(getState());
        const favorites = getFavorites(appState);

        const matchingFavorite = getMatchingFavorite(updatedHubPersona, favorites);

        if (matchingFavorite) {
            dispatch(editFavoritePersona(matchingFavorite.favoriteId, updatedInfo));
        }
    });
